import { render, staticRenderFns } from "./MisPacientes.vue?vue&type=template&id=0895278a&scoped=true&"
import script from "./MisPacientes.vue?vue&type=script&lang=js&"
export * from "./MisPacientes.vue?vue&type=script&lang=js&"
import style0 from "./MisPacientes.vue?vue&type=style&index=0&id=0895278a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895278a",
  null
  
)

export default component.exports